import { gql } from '@apollo/client'

export const REPORT_USER_CONTENT = gql`
  mutation ReportUserContent($input: ReportUserContentInput!) {
    reportUserContent(input: $input) {
      success
      errors
    }
  }
`
